import React from 'react';

const I18NContext = React.createContext(null);

export default I18NContext;
